import { Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DialogService, CoreService, HttpService, StatistiqueDetailApprenantEL, StatistiqueModel, StatistiqueDetailCycleEL, ConnectedUser, QResult, ApprenantEL, StatistiqueChapterEL, eEtatAvancement, AnswerModel, LearnerDetail, ToastService, FileModel, FilesManagerService } from 'projects/lib-components/src/public_api';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';



@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-learner-stats',
  templateUrl: './learner-stats.component.html',
  styleUrls: ['./learner-stats.component.css']
})



export class LearnerStatsComponent implements OnInit {

  // Idents
  public identCycle: string;
  public DetailApprenantEL: StatistiqueDetailApprenantEL;
  public DetailCycleEL: StatistiqueDetailCycleEL;
  public loaded: boolean = false;
  public showData: boolean = true;
  public identChapitre: string;
  public identApprenant: string;
  public arrayCircle: any[];

  public dataUser: ConnectedUser;

  public showListLearner: boolean;

  public learnerList: Array<ApprenantEL>;

  public IsMobile: boolean;

  @ViewChild('cycleContainer') cycleContainer: ElementRef;


  // #region constructeur
  constructor(
    protected activatedRouter: ActivatedRoute,
    protected indParam: CoreService,
    protected http: HttpService,
    protected router: Router,
    protected domSanitizer: DomSanitizer,
    private renderer: Renderer2,
    protected dialogservice: DialogService,
    protected toastservice: ToastService,
    protected fileService: FilesManagerService
  ) { }
  // #endregion

  // #region variables gloables
  // #endregion

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.IsMobile = window.innerWidth < 750
  }

  // #region cycle de vie
  ngOnInit(): void {

    this.IsMobile = window.innerWidth < 750

    this.showListLearner = false;

    // Pas de rôle -> affichage de stats de la personne connectée
    if (!this.indParam.AppParams.Role) {
      this.identApprenant = this.indParam.AppParams.LoggedUser.Ident;
      this.getApprenantDetail('0');
    }
    else {
      // Comportement différent selon le rôle
      switch (this.indParam.AppParams.Role.Id) {
        // Rôle RH -> Récupération des apprenants ayant un cycle el liés aux stages actifs des conventions de la personne connectée
        case '4':
          this.getListApprenantRH();
          break;
        // Rôle Admin / formateur -> Récupération des apprenants ayant un cycle el liés aux stages actifs sur lequel la personne connectée est formateur
        case '1':
        case '2':
          this.getListApprenantFormateur();
          break;
        default:
          // Tout autre rôle -> récupération des stats de la personne connectée
          this.identApprenant = this.indParam.AppParams.LoggedUser.Ident;
          this.getApprenantDetail('0');
      }
    }


  }

  /**
   * Récupération de la liste des apprenants liés au RH
   */
  public getListApprenantRH(): void {
    this.dialogservice.showSplash(true);
    // this.identApprenant = this.indParam.AppParams.LoggedUser.Ident;
    this.http.getHttp<QResult<StatistiqueModel>>(`${this.indParam.AppParams.UrlExtranetWS}api/statistique/el/GetListApprenantRH/${this.indParam.AppParams.LoggedUser.Ident}`).subscribe((result: QResult<StatistiqueModel>) => {
      if (!result.HasError) {
        this.learnerList = result.Value.StatElearning.ListApprenantEL;
        this.showListLearner = true;

        // Ajout de la personne connectée dans la liste
        const user = new ApprenantEL();
        user.Ident = this.indParam.AppParams.LoggedUser.Ident;
        user.Prenom = this.indParam.AppParams.LoggedUser.Pre01PER;
        user.Nom = this.indParam.AppParams.LoggedUser.NomfaPER;
        this.learnerList.unshift(user);

        // affichage par défaut des stats de la personne connectée
        this.identApprenant = this.learnerList[0].Ident;
        this.getApprenantDetail('0');


      }


      this.dialogservice.showSplash(false);
    });
  }

  /**
   * Récupération de la liste des apprenants liés au formateur
   */
  public getListApprenantFormateur(): void {
    this.dialogservice.showSplash(true);
    // this.identApprenant = this.indParam.AppParams.LoggedUser.Ident;
    this.http.getHttp<QResult<StatistiqueModel>>(`${this.indParam.AppParams.UrlExtranetWS}api/statistique/el/GetListApprenantFormateur/${this.indParam.AppParams.LoggedUser.Ident}`).subscribe((result: QResult<StatistiqueModel>) => {
      if (!result.HasError) {
        this.learnerList = result.Value.StatElearning.ListApprenantEL;
        this.showListLearner = true;

        // Ajout de la personne connectée dans la liste
        const user = new ApprenantEL();
        user.Ident = this.indParam.AppParams.LoggedUser.Ident;
        user.Prenom = this.indParam.AppParams.LoggedUser.Pre01PER;
        user.Nom = this.indParam.AppParams.LoggedUser.NomfaPER;
        this.learnerList.unshift(user);

        // affichage par défaut des stats de la personne connectée
        this.identApprenant = this.learnerList[0].Ident;
        this.getApprenantDetail('0');


      }


      this.dialogservice.showSplash(false);
    });
  }

  /**
   * Sélection de l'apprenant
   * @param idLearner
   */
  public selectLearner(idLearner: string): void {
    this.identApprenant = idLearner;
    if (idLearner == '') {
      this.loaded = false;
    }
    else {
      this.loaded = false;
      this.getApprenantDetail('0');
    }

  }

  /**
   * Sélection du cycle
   * @param idCycle
   */
  public selectCycle(idCycle: string): void {
    this.identCycle = idCycle;
    this.getApprenantDetail(idCycle);
  }


  //returnImgChapter(url: string): SafeResourceUrl {
  //  return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  //}


  /**
   * Récupération des stats de l'apprenant
   * @param idCycle
   */
  public getApprenantDetail(idCycle: string): void {

    this.dialogservice.showSplash(true);
    // this.identApprenant = this.indParam.AppParams.LoggedUser.Ident;
    this.http.getHttp<QResult<StatistiqueModel>>(`${this.indParam.AppParams.UrlExtranetWS}api/statistique/el/GetApprenantDetail/${idCycle}|${this.identApprenant}`).subscribe((result: QResult<StatistiqueModel>) => {
      if (!result.HasError) {
        this.DetailApprenantEL = result.Value.StatElearning.DetailApprenantEL;
        this.DetailApprenantEL.ModuleTermine = this.DetailApprenantEL.ModuleTermine ? this.DetailApprenantEL.ModuleTermine : '0';
        this.DetailApprenantEL.QuestionTraitee = this.DetailApprenantEL.QuestionTraitee ? this.DetailApprenantEL.QuestionTraitee : '0';
        this.DetailApprenantEL.TauxReussite = this.DetailApprenantEL.TauxReussite ? this.DetailApprenantEL.TauxReussite : '0';
        this.DetailApprenantEL.TempsPasse = this.DetailApprenantEL.TempsPasse ? this.DetailApprenantEL.TempsPasse : '0';
        if (result.Value.StatElearning.DetailApprenantEL.ListChapitre) {
          if (result.Value.StatElearning.DetailApprenantEL.ListChapitre.length > 0) {
            this.identChapitre = result.Value.StatElearning.DetailApprenantEL.ListChapitre[0]['Ident'];
          }
        }
        if (result.Value.StatElearning.DetailApprenantEL.CycleInfo) {
          if (idCycle === '0' && result.Value.StatElearning.DetailApprenantEL.CycleInfo.length > 0) {
            this.identCycle = result.Value.StatElearning.DetailApprenantEL.CycleInfo[0].identCyc.toString();
          }
        }


      }

      this.showData = this.DetailApprenantEL.InfoApprenant && this.DetailApprenantEL.InfoApprenant.length > 0;
      this.getArrayCicle();
      this.GetCycleDetail();

     // this.dialogservice.showSplash(false);
    });
  }

  /**
   * Ouverture accordéon d'un chapitre
   * @param event
   */
  public expendList(event: any, chapter: StatistiqueChapterEL) {

    // let element: any = event.currentTarget ? event.currentTarget.parentElement : event;

    // élément à ouvrir
    let element: any = event.currentTarget.parentElement.getElementsByClassName('list-closed').length > 0 ? event.currentTarget.parentElement.getElementsByClassName('list-closed')[0] : event.currentTarget.parentElement.getElementsByClassName('list-expanded')[0];

    // element = event.currentTarget;
    if (element) {
      if (element.classList.contains('list-closed')) {
        this.renderer.removeClass(element, 'd-none');
        this.renderer.removeClass(element, 'list-closed');
        this.renderer.addClass(element, 'list-expanded');
        this.renderer.setStyle(element, 'max-height', `${element.scrollHeight}px`);
        this.renderer.removeClass(event.currentTarget.querySelector('i'), 'fa-chevron-down');
        this.renderer.addClass(event.currentTarget.querySelector('i'), 'fa-chevron-up');
        chapter.IsOpen = true;
      } else {
        this.renderer.addClass(element, 'list-closed');
        this.renderer.removeClass(element, 'list-expanded');
        this.renderer.setStyle(element, 'max-height', `0`);
        this.renderer.removeClass(event.currentTarget.querySelector('i'), 'fa-chevron-up');
        this.renderer.addClass(event.currentTarget.querySelector('i'), 'fa-chevron-down');
        chapter.IsOpen = false;
        setTimeout(() => {
          this.renderer.addClass(element, 'd-none');
        }, 200);

      }
    }
  }

  /**
   * Retourne les classes pour l'icone d'avancement
   */
  public getEtat(etat: eEtatAvancement): string {
    if (etat == eEtatAvancement.END) {
      return 'fas fa-check-circle icon-big q-c-success';
    }
    if (etat == eEtatAvancement.PROGRESS) {
      return 'fas fa-play-circle icon-big q-c-primary';
    }
    else {
      return 'fas fa-dot-circle icon-big q-c-dark-grey';
    }
  }

  /**
   * Retourne le temps passé en heure min
   * @param timeInSec
   * @returns
   */
  getTimeSpend(timeInSec: number): string {
    let nbHours = Math.floor((timeInSec / 3600) % 60);
    let nbMin = Math.floor((timeInSec / 60) % 60);
   // let nbSec = Math.floor(timeInSec % 60);
    return `${nbHours}h ${nbMin}min`;
  }

  /**
   * Retourne le texte avec le nombre de passage
   * @param nbPassage
   * @returns
   */
  getTextPassage(nbPassage: number): string {
    if (nbPassage == 0) {
      return this.indParam.getTrad('Notstarted');
    }
    if (nbPassage == 1) {
      return '1 passage';
    }
    else {
      return `${nbPassage} passages`;
    }
  }

  public downloadQuest(idModule: string) {
    let model: AnswerModel = new AnswerModel();
    model = new AnswerModel();
    model.Mode = "toPdf";
    model.lessonId = idModule;
    model.modelType = 'Validation';
    model.learnerId = this.identApprenant;
    model.modeQuestionnaire = "pdf";
    let learner = new LearnerDetail();
    learner.ident = this.identApprenant;
    learner.questionnaireCompleted = true;
    model.learnerList = [learner];
    //  model.modeQuestionnaire = 'trainer'; 
   // model.modelName = this.listQuestionnaire.ModelNameQuestionnaire;
    model.isTrainer = true;
    // model.formateurName = `${this.appService.Params.FirstName} ${this.appService.Params.Name}`;
    this.toastservice.showInfoToast('Fichier en cours de génération ...');
    this.http.postHttp<AnswerModel>(`${this.indParam.AppParams.UrlElearningWS}api/questionnaire/`, model).subscribe((data: AnswerModel) => {
      if (!data.HasError) { }
      const fileModel: FileModel = new FileModel();
      fileModel.DownloadMode = 'OPENFILE';
      fileModel.FullPath = data.fileToDl;
      fileModel.Name = this.identApprenant + '.pdf';
      this.fileService.downloadMedia(fileModel, false);
      this.indParam.showSplash(false);
    });
  }

  // #region private function 

  /**
   * Récupération des stats d'un cycle pour un apprenant
   */
  private GetCycleDetail(): void {

    if (this.identCycle && this.identCycle !== '') {
      this.dialogservice.showSplash(true);
      this.http.getHttp<QResult<StatistiqueModel>>(`${this.indParam.AppParams.UrlExtranetWS}api/statistique/el/GetCycleDetail/${this.identCycle}|${this.identApprenant}`).subscribe((result: QResult<StatistiqueModel>) => {
        if (!result.HasError) {
          this.DetailCycleEL = result.Value.StatElearning.DetailCycleEL;
          this.loaded = true;
        }
        this.dialogservice.showSplash(false);
      });
    } else {
      this.loaded = true;
      this.showData = false;
      // Affichage des données de l'utilisateur
      this.dataUser = this.indParam.AppParams.LoggedUser;
      this.dialogservice.showSplash(false);
    }

  }

  private getArrayCicle(): any {
    this.arrayCircle = [
      {
        // title: 'questionsAnswered',
        title: 'exercisesPerformed',
        value: this.DetailApprenantEL.QuestionTraitee,
        modal: '#',
        fontAwsome: 'fas fa-question-circle',
        flip: false
      },
      {
        title: 'modulesCompleted',
        value: this.DetailApprenantEL.ModuleTermine,
        modal: Number(this.DetailApprenantEL.ModuleTermine) > 0 ? '#modalModuleCompleted' : '',
        fontAwsome: 'fas fa-flag',
        flip: Number(this.DetailApprenantEL.ModuleTermine) > 0
      },
      {
        title: 'timeSpent',
        value: this.DetailApprenantEL.TempsPasse,
        modal: '#',
        fontAwsome: 'fas fa-clock',
        flip: false
      },
      {
        title: 'successRate',
        value: this.DetailApprenantEL.TauxReussite,
        modal: '#',
        fontAwsome: 'fas fa-tachometer-alt',
        flip: false
      }
    ];
  }

  // #endregion
 
  // #endregion

  public getUrl(url: string): string {
    return this.domSanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64, ' + url) as string;
  }

  public returnImgChapter(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
